import React from 'react';
import { Award, Users, CheckCircle } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingIncludes = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-20 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-foreground mb-12 text-center">
          {language === 'fr' ? 'Inclus dans chaque formation' : 'Included in Every Training'}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Award className="w-8 h-8 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{t('trainingCertification')}</h3>
            <p className="text-muted-foreground text-sm">
              {language === 'fr' 
                ? 'Attestation de formation délivrée à chaque participant'
                : 'Certificate issued to all participants'}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Users className="w-8 h-8 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{t('trainingMaterials')}</h3>
            <p className="text-muted-foreground text-sm">
              {language === 'fr'
                ? 'Supports de cours complets et ressources additionnelles'
                : 'Comprehensive course materials and additional resources'}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{t('trainingSupport')}</h3>
            <p className="text-muted-foreground text-sm">
              {language === 'fr'
                ? 'Accompagnement et questions-réponses après la formation'
                : 'Follow-up support and Q&A after training'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
